<style scoped>
  .ivu-spin {
    display: inline-block;
  }
</style>
<template>
  <div>
    <table class="mis-table">
      <tr>
        <th>团队</th>
        <th>预算汇报人</th>
        <th>财务分析人员</th>
        <th>HRBP</th>
      </tr>
      <tr
        v-for="tc in team_customers"
        :key="tc.id"
      >
        <td>{{ tc.name }}</td>
        <td>
          <CustomerSelector
            type="text"
            :long="false"
            @on-change="(budget_customer) => { setCustomer(tc.id, tc.customer, budget_customer,tc.hrbp) }"
          >
            <div>
              <Spin v-if="team_loading_hash[tc.id]" />
              <span
                v-if="tc.budget_customer"
                class="link"
              >
                {{ tc.budget_customer.account }}
                <span
                  v-if="tc.budget_customer.quit"
                  class="color-error"
                >(已离职)</span>
              </span>
              <span
                v-else
                class="color-grey"
              >请设置</span>
            </div>
          </CustomerSelector>
        </td>
        <td>
          <CustomerSelector
            type="text"
            :long="false"
            @on-change="(customer) => { setCustomer(tc.id, customer, tc.budget_customer,tc.hrbp) }"
          >
            <div>
              <Spin v-if="team_loading_hash[tc.id]" />
              <span
                v-if="tc.customer"
                class="link"
              >
                {{ tc.customer.account }}
                <span
                  v-if="tc.customer.quit"
                  class="color-error"
                >(已离职)</span>
              </span>
              <span
                v-else
                class="color-grey"
              >请设置</span>
            </div>
          </CustomerSelector>
        </td>
        <td>
          <CustomerSelector
            type="text"
            :long="false"
            @on-change="(hrbp) => { setCustomer(tc.id, tc.customer, tc.budget_customer,hrbp) }"
          >
            <div>
              <Spin v-if="team_loading_hash[tc.id]" />
              <span
                v-if="tc.hrbp"
                class="link"
              >
                {{ tc.hrbp.account }}
                <span
                  v-if="tc.hrbp.quit"
                  class="color-error"
                >(已离职)</span>
              </span>
              <span
                v-else
                class="color-grey"
              >请设置</span>
            </div>
          </CustomerSelector>
        </td>
      </tr>
    </table>
  </div>
</template>
<script route="/team_fin_customer/list">
  import CustomerSelector from '../components/customer/selector';
  import {mapGetters} from "vuex";

  export default {
    /* router_info_start */
    router_info: '/team_fin_customer/list',
    /* router_info_end */
    components: { CustomerSelector },
    data() {
      return {
        team_customer_hash: {},
        loading: false,
        team_loading_hash: {}
      }
    },
    computed: {
      ...mapGetters({
        root_teams: 'async/root_teams',
      }),
      team_customers() {
        const teams = [];
        this.root_teams.forEach((team) => {
          if (!team.del) {
            const tc = this.$util.clone(team);
            if (team.id in this.team_customer_hash) {
              const {customer, budget_customer, hrbp} = this.team_customer_hash[team.id]
              tc.customer = customer;
              tc.budget_customer = budget_customer;
              tc.hrbp = hrbp
            }
            teams.push(tc);
          }
        });
        return teams;
      }
    },
    created() {
      this.getRecords();
    },
    mounted() {
      //
    },
    methods: {
      getRecords() {
        this.loading = true;
        this.$util.ajax.get(this.$util.api.team_fin_customer_list, {
          params: {}
        }).then((response) => {
          return response.data;
        }).then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.genTeamCustomerHash(res.data.records);
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.loading = false;
        });
      },
      genTeamCustomerHash(records) {
        const hash = this.$util.clone(this.team_customer_hash);
        records.forEach((record) => {
          const {customer, budget_customer, hrbp} = record;
          hash[record.team_id] = {customer, budget_customer, hrbp}
        });
        this.team_customer_hash = hash;
      },
      setCustomer(team_id, customer, budget_customer, hrbp) {
        this.$set(this.team_loading_hash, team_id, true);
        this.$util.ajax.post(this.$util.api.update_team_fin_customer, {
          team_id: team_id,
          customer_id: (customer && customer.id) || null,
          budget_customer_id: (budget_customer && budget_customer.id) || null,
          hrbp_id: (hrbp && hrbp.id) || null,
        }).then((response) => {
          return response.data;
        }).then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.genTeamCustomerHash([res.data.record]);
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.$set(this.team_loading_hash, team_id, false);
        });
      }
    }
  }
</script>
